import React from "react";
import { DatePicker, Space, Select, Input, Button, Card, Typography } from "antd";
import { SearchOutlined, DownloadOutlined, FileExcelOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Text } = Typography;

export default function RazaoHeader({
    dates,
    setDates,
    contaContabilId,
    setContaContabilId,
    contasContabeis,
    nomeLancamento,
    setNomeLancamento,
    valorSearch,
    setValorSearch,
    handlePesquisar,
    showConfirm,
    exportLivroRazaoExcel,
    lancamentos
}) {
    return (
        <Card size="small" className="premium-card filter-card" style={{ marginBottom: 24, padding: '12px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <Text strong style={{ color: '#475569', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Parâmetros de Pesquisa
                </Text>

                <Space wrap size="middle">
                    <DatePicker.RangePicker
                        picker="month"
                        format="MM/YYYY"
                        size="large"
                        value={dates}
                        onChange={(val) => {
                            if (val) setDates(val);
                        }}
                        style={{ borderRadius: '10px', width: 280 }}
                    />

                    <Select
                        showSearch
                        allowClear
                        placeholder="Todas as Contas"
                        size="large"
                        value={contaContabilId || undefined}
                        onChange={setContaContabilId}
                        style={{ width: 350 }}
                        dropdownStyle={{ borderRadius: '12px' }}
                        optionFilterProp="label"
                    >
                        {contasContabeis.map(c => (
                            <Option key={c.id} value={c.id} label={`${c.codigo} - ${c.nome}`}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{ fontWeight: 700, color: '#1890ff', marginRight: 12 }}>{c.codigo}</span>
                                    <span style={{ color: '#475569' }}>{c.nome}</span>
                                </div>
                            </Option>
                        ))}
                    </Select>

                    <Input
                        placeholder="Histórico..."
                        size="large"
                        value={nomeLancamento}
                        onChange={e => setNomeLancamento(e.target.value)}
                        style={{ width: 180, borderRadius: '10px' }}
                        allowClear
                    />

                    <Input
                        placeholder="Valor..."
                        size="large"
                        value={valorSearch}
                        onChange={e => setValorSearch(e.target.value)}
                        style={{ width: 120, borderRadius: '10px' }}
                        allowClear
                        prefix={<span style={{ color: '#1890ff', fontWeight: 'bold' }}>R$</span>}
                    />

                    <Button
                        type="primary"
                        size="large"
                        icon={<SearchOutlined />}
                        onClick={() => handlePesquisar()}
                        className="btn-gradient"
                        style={{ width: 140 }}
                    >
                        Pesquisar
                    </Button>

                    <div style={{ marginLeft: 'auto', display: 'flex', gap: 10 }}>
                        <Button
                            size="large"
                            icon={<DownloadOutlined />}
                            onClick={showConfirm}
                            style={{ borderRadius: '10px', fontWeight: 600, border: '1px solid #e2e8f0' }}
                        >
                            PDF
                        </Button>
                        <Button
                            size="large"
                            icon={<FileExcelOutlined />}
                            onClick={() => exportLivroRazaoExcel(lancamentos)}
                            style={{ borderRadius: '10px', fontWeight: 600, border: '1px solid #e2e8f0', color: '#16a34a' }}
                        >
                            Excel
                        </Button>
                    </div>
                </Space>
            </div>
        </Card>
    );
}
